import React from "react";
import Facebook from "../../../assets/icons/facebook-f.svg";
import Linkedin from "../../../assets/icons/linkedin-in.svg";
import Youtube from "../../../assets/icons/iconmonstr-youtube-1.svg";
import "./Footer.css";
import { AppContext } from "../../core/ApplicationContextProvider";

const Footer = () => {
  const { details } = React.useContext(AppContext);
  const dataPolicyUrl =
    (details &&
      details.businessLineDetails &&
      details.businessLineDetails.dataPolicyUrl) ||
    "https://www.nn.ro/prelucrare-date";

  return (
    <div className="footer">
      <div className="container pl-0 pt-3 pb-2 pb-md-0 pt-md-2">
        <div className="row">
          <div className="col-12 col-md-6 align-center-sm align-left-md pl-0 pr-0">
            <a href="https://www.nn.ro/acasa" className="footer-link">
              NN Romania
            </a>
            <span className="d-none d-md-inline-block ml-1 mr-1">|</span>
            <a href="https://www.nn-group.com/Home.htm" className="footer-link">
              NN Group
            </a>
          </div>
          <div className="col-12 col-md-6 pr-0 align-center-sm align-right-md">
            <a
              href="https://www.nn.ro/termeni-conditii"
              className="footer-link"
            >
              Termeni și condiții
            </a>
            <span className="d-none d-md-inline-block ml-1 mr-1">|</span>
            <a href={dataPolicyUrl} className="footer-link">
              Prelucrare date
            </a>
            <span className="d-none d-md-inline-block ml-1 mr-1">|</span>
            <a
              href="https://www.nn.ro/parerea-despre-nn.ro"
              className="footer-link"
            >
              Părerea ta despre nn.ro
            </a>
          </div>
        </div>
      </div>
      <hr className="mt-2 mb-2" />
      <div className="container pl-0 mb-2 pb-2">
        <div className="row">
          <div className="col-12 col-md-6 align-center-sm align-left-md pl-0 pr-0 pt-2 pb-2 pt-md-0 pb-md-0">
            <a
              href="https://www.facebook.com/NNRomania"
              className="social-icon"
            >
              <img
                src={Facebook}
                alt="Facebook"
                className="d-inline-block align-top"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/nn/"
              className="social-icon"
            >
              <img
                src={Linkedin}
                alt="Linkedin"
                className="d-inline-block align-top"
              />
            </a>
            <a
              href="https://www.youtube.com/c/nnromania"
              className="social-icon"
            >
              <img
                src={Youtube}
                alt="Youtube"
                className="d-inline-block align-top"
              />
            </a>
          </div>
          <div className="col-12 col-md-6 pr-0 align-center-sm align-right-md align-self-center">
            © NN Romania. Toate drepturile rezervate
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
